<template lang="pug">
    .z-input-autocomplete(ref="parent" v-bind:class="{ inline: inline }")
        .z-input-autocomplete-container
            z-input(
                v-bind:light="$props.light"
                v-bind:name="name" 
                v-bind:id="$props.id" 
                v-bind:label="$props.label" 
                v-model="searchString" 
                v-bind:error="inputError"
                v-bind:mask="$props.mask"
                v-on:focus="onFocus"
                v-bind:disabled="disabled || isSelected"
                v-bind:loading="loading"
                v-bind:inline="inline"
                v-bind:placeholder="$props.placeholder"
                ref="input"
                autocomplete="off"
                v-validate="$props.validate"
                v-bind:data-vv-as="' '"
                v-bind:dirty.sync="isDirty"
                v-bind:no-resize="$props.noResize"
            )
                .list-container(v-show="showMenu")
                    .list.can-scroll(ref="list")
                        .item(v-for="(item, index) in findResult" v-bind:key="index" v-on:click="selectItem(item, $event, true)")
                            span {{item[listProperty]}}
            .button-bar(v-if="!$props.disabled")
                .btn(v-on:click="onClear(true)" v-show="isSelected" v-bind:class="{light: $props.light}")
                    <fa-icon v-bind:icon="['fa', 'times']"></fa-icon>
                .btn(v-on:click="onSave(true)" v-show="$props.showSaveBtn && isSelected" v-bind:class="{light: $props.light}")
                    <fa-icon v-bind:icon="['fa', 'check']"></fa-icon>
        input(v-if="$props.required" type="checkbox" name="isSelected" v-model="isSelected" v-validate="'required'" data-vv-as=" " style="visibility: hidden; display: none;")
</template>
<script>
    import ZInput from '@/components/ZInput'
    export default {
        components: {ZInput},
        name: 'autocomplete',
        props: {
            placeholder: {
                type: String,
                default: null,
                required: false
            },
            items: { //массив с объектами элементов, по которым будет идти поиск - [{id: 1, name: 'name 1'}, {id: 2, name: 'name 2'}]
                type: Array,
                default: () => {
                    return [];
                },
                required: false
            },
            property: { //свойство объектов в массиве, по значению которого будет идти поиск - name
                type: String,
                default: 'id',
                required: true
            },
            lengthOnSearch: {
                type: Number,
                default: 3,
                required: false
            },
            displayProperty: { //свойство объектов в массиве, коорое будет выводиться в списке поиска
                type: String,
                default: 'name',
                required: true
            },
            displayPropertyList: {
                type: String,
                default: null,
                required: false
            },
            returnAll: { //Если установленно в true, то возвращает целиком объект, а не значение строки поиска
                type: Boolean,
                default: false
            },
            clearAfterSelect: { //если передать true, поле поиска будет очищаться после выбора
                type: Boolean,
                default: false
            },
            label: { //заголовок для поля
                type: String,
                default: null,
                required: false
            },
            value: { //значение поля, должно быть = свойству, указнному в return, для одного из элементов - 2
                type: [String, Number],
                default: () => null,
                required: false
            },    
            callback: { //функция, которая возвращает список для автозаполнения
                type: Function,
                required: false,
            },
            default: { //текстовое значение поля, если используется callback,
                type: [String, Number],
                default: () => null,
                required: false 
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: null,
                required: false
            },
            required: {
                type: Boolean,
                default: false
            }, 
            id: {
                type: String,
                default: 'z-input-autocomplete',
                required: true
            },
            name: {
                type: String,
                default: 'z-input-autocomplete',
                required: true
            },
            mask: {
                type: String,
                default: null,
                required: false
            },
            showSaveBtn: {
                type: Boolean,
                default: false
            },
            inline: {
                type: Boolean,
                default: false
            },
            updateOnInput: {
                type: Boolean,
                default: false
            },
            validate: {
                type: [String, Object],
                default: () => null
            },
            noResize: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searchString: null,   //Поле поиска, в которое пользователь вводит запрос
                findResult: [],       //Результаты поиска, массив заполняется либо из $props.items либо при помощи $props.callback функции
                showMenu: false,      //Флаг, показывает нужно ли отображать выпадающее меню
                isFocused: false,     //Флаг, показывает в фокусе ли сейчас поле ввода
                listProperty: 'name', //Поле, которое нужно показывать пользователю из объектов поиска
                loading: false,       //Флаг, показывает идёт ли сейчас поиск результатов через $props.callback функцию
                isSelected: false,    //Флаг, показывает выбрано ли значение поьзователем из списка, либо установленно ли родительским компонентом
                blurListener: null,   //Слушатель blur события компонента
                isDirty: false,
            }
        },
        created() {
            this.$nextTick(() => {
                this.findResult   = Object.assign([], this.$props.items);
                this.searchString = (this.default) ? this.default : null;

                this.getListDisplayProperty();
                this.checkSelect();
            });
        },
        computed: {
            /**
             * Показывает ошибку, если пользователь не выбрал значение из списка
             */
            inputError() {
                let error = null;
                
                if (this.errors.has(this.$props.name)) error = this.errors.first(this.$props.name);
                else if (this.errors.has('isSelected')) error = 'Необходимо выбрать значение из списка'
                else error = this.$props.error;
                
                return error;
            }
        },
        methods: {
            getListDisplayProperty() {
                if (this.$props.displayPropertyList) this.listProperty = this.$props.displayPropertyList;
                else this.listProperty = (this.$props.displayProperty) ? this.$props.displayProperty : this.$props.property;
            },
            /**
             * Очищает валидацию значения в компоненте
             */
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
            },
            /**
             * Слушатель событий
             * blurListener - слушает события когад пользователь кликает вне компонента, чтобы скрыть выпадающий список
             */
            listeners() {
                this.blurListener = document.addEventListener('click', e => {
                    if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.onBlur();
                });
            },
            /**
             * Вызывается при фокусе поля поиска
             */
            onFocus(e) {
                this.listeners();
                this.isFocused = true;
                if (this.$props.items && this.$props.items.length) {
                    this.findResult = Object.assign([], this.$props.items);
                    this.showMenu   = true;
                }
            },
            /**
             * Вызывается когда поле поиска теряет фокус
             */
            onBlur(e) {
                document.removeEventListener('click', this.blurListener, false);
                this.isFocused = false;
                this.showMenu  = false;
                this.$emit('blur');
                this.$validator.validateAll();
            },
            /**
             * Вызвается только когда пользователь кликает на кнопку "Сохранить" в поле поиска
             */
            onSave(userSave = false) {
                this.$emit('save');
                if (userSave) this.emitDirty();
            },
            /**
             * Вызвается если нужно очистить значение поля поиска и значение v-model (Оно очищается в watch:{'searchString'})
             */
            onClear(userClear = false) {
                this.isSelected   = false;
                this.searchString = null;
                this.$emit('clear');
                if (userClear) this.emitDirty();
            },
            /**
             * Вызывается когда пользователь начинает печатать (или вставляет значение) в поле поиска
             */
            search() {
                if (!this.isFocused) return;
                this.findResult = [];
                if (this.$props.callback && typeof this.$props.callback === 'function') { //Если передали callback функцию, то ищем элементы через неё
                    if (this.loading) return;
                    this.loading = true;
                    this.$props.callback(this.searchString).then(result => {
                        if (!result) return [];
                        if (result.body && result.body.response) {
                            if (result.body.response.data) this.findResult = Object.assign([], result.body.response.data);
                            else this.findResult = Object.assign([], result.body.response);
                        } else this.findResult = Object.assign([], result);
                        if (Object.keys(this.findResult).length) this.showMenu = true;
                    }).finally(() => this.loading = false);
                } else { //Иначе ищем в переданном массиве элементов
                    if (Object.keys(this.$props.items).length && this.searchString) Object.keys(this.$props.items).forEach((key) => {
                        let item = this.$props.items[key];
                        if ((item[this.property].toLowerCase().indexOf(this.searchString.toLowerCase()) + 1)) this.findResult.push(item);
                    });
                    
                    if (!this.searchString || !this.searchString.length) this.findResult = this.$props.items;
                    if(Object.keys(this.findResult).length) this.showMenu = true;
                }
            },
            /**
             * Вызывается когда пользователь кликает по одному из элементов в списке
             * Устанавливает значение поля поиска и возвращает выбранный объект в событии select
             */
            selectItem(item, $event, userEvent = false) {
                this.$nextTick(() => {
                    let result;
                    if (this.returnAll) result = item;
                    else result = item[this.property];
                    this.searchString = item[this.displayProperty];

                    this.$emit('select', result, Object.assign({}, item));
                    this.$emit('input', result);

                    this.$nextTick(() => {
                        this.findResult = [];
                        if (this.clearAfterSelect) this.searchString = null;
                        this.isSelected = true;
                        this.onBlur();
                        if (userEvent) this.emitDirty();
                    });
                });
            },
            /**
             * Вызывается только родительскими компонентами, когда необходимо принудительно установить значение поля
             */
            select(value) {
                if (value) {
                    this.$emit('input', value);
                    this.searchString = value;
                }
                this.isSelected = true;
                this.onBlur();
            },
            /**
             * Проверяет выбранно ли значение в поле ввода. 
             * Нужно когда загружается уже заполненная форма (с существующей сущностью) и надо чекнуть, что поле заполненно
             */
            checkSelect() {
                this.$nextTick(() => {
                    if (!this.isFocused && this.default) this.isSelected = true;
                });
            },
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            }
        },
        watch: {
            '$prop.displayPropertyList'(){
                this.getListDisplayProperty();
            },
            '$props.displayProperty'() {
                this.getListDisplayProperty();
            },
            /**
             * Слушает изменение скроки поиска, запускает поиск по элементам/через коллбек
             * Устанавливает значение в v-model, если это требуется
             */
            'searchString'(value, oldValue) {
                if (!value) { //Если нет значения, или нужно его возвращать при вводе текста в поле поиска, то вызываем событие input, чтобы обновить значение в v-model
                    this.$emit('input', null);
                    //Возвращаем список выбора, если он передан т.к. поле поиска у нас пустое
                    if (this.$props.items && this.$props.items.length) this.findResult = Object.assign([], this.$props.items);
                }
                if (this.$props.updateOnInput && !this.$props.value) this.$emit('input', value);
                this.isSelected = false;

                //Стартуем поиск только если значение в стркое поиска не менялось в течении полутора секунд
                setTimeout(() => {
                    if (value && value == this.searchString && value && value.length >= this.$props.lengthOnSearch && this.isFocused && !this.loading) this.search();
                }, 1500);

                //if (!this.$props.return || this.$props.property == this.$props.return) this.$emit('input', value);
                //if (this.$props.displayProperty == this.$props.return) this.$emit('input', value);
            },
            /**
             * Слушает изменение v-model, актуализирует поле поиска, в соответствии с значением v-model
             */
            '$props.value'(value) {
                if (!this.searchString) this.searchString = value;
                if (value) this.checkSelect();
                else this.searchString = '';
            },
            /**
             * Слушает изменение поля дефолтного значения поля
             * Нужно когда загружается уже заполненная форма (с существующей сущностью) и надо чекнуть, что поле заполненно
             */
            'default'(value) {
                if (!this.searchString) this.searchString = this.default;
                if (value) this.checkSelect(); //если инпут не выделен, значит сработало автозаполнение с другого инпута и можно выставить флаг выбора
            },
            /**
             * Отслеживает обновление списка элементов, т.к. он не всегда доступен сразу при создании компонента
             */
            '$props.items'(items) {
                this.findResult = Object.assign([], this.$props.items);
            },
            'dirty'(val) {
                if (val) this.emitDirty();
            }
        }
    }
</script>
<style lang="sass">
  .z-input-autocomplete
    width: 100%
    .z-input-autocomplete-container
      position: relative
      .button-bar
        position: absolute
        z-index: 15
        right: 2px
        bottom: 2px
        height: 26px
        display: flex
        align-items: center
        justify-content: flex-end
        .btn
          height: 22px
          width: 22px
          display: flex
          align-items: center
          justify-content: center
          cursor: pointer
          border-radius: 100%
          transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1)
          will-change: background-color,opacity
          margin: 0 0 0 5px
          &:hover
            background: rgba(33, 33, 33, 0.12)
          &.light
            color: #000
          svg
            display: block
            width: 14px
            height: 14px
            font-size: 15px
            line-height: 14px
            box-sizing: border-box
            vertical-align: baseline
    .md-menu
      width: 100%
      .md-input
        width: 100%
    .list-container
        position: relative
        width: 100%
        .list
            position: absolute
            background: #fff
            box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)
            z-index: 1000
            min-width: 100%
            max-height: 300px
            right: 0
            overflow: auto
            .item
                padding: 2px 10px
                font-size: 12px
                line-height: 14px
                transition: .3s cubic-bezier(.4,0,.2,1);
                cursor: pointer
                color: #000
                &:hover
                    background: var(--md-theme-white-highlight-on-background, rgba(0, 0, 0, 0.08))
                &:nth-last-child(odd)
                    background: #fafafa
                    &:hover
                        background: var(--md-theme-white-highlight-on-background, rgba(0, 0, 0, 0.08))
    &.inline
        .button-bar
            top: 2px
  .z-input-autocomplete.inline
    .list-container
        .list
            min-width: 60%
            width: 60%
</style>



// WEBPACK FOOTER //
// ZInputAutocomplete.vue?f59bd52a